import PricingTableComponent from './PricingTableComponent';

import {useOutletContext} from 'react-router-dom';

interface OutletContextType {
  debouncedSearchTerm: string;
}

const PricingTable = () => {
  const {debouncedSearchTerm} = useOutletContext<OutletContextType>();

  return <PricingTableComponent searchText={debouncedSearchTerm} />;
};

export default PricingTable;
